export const groupMediaByType = (media) => {
  if (!media) {
    return []
  }

  const groupedMedia = []

  media
    .map((file) => ({
      ...file,
      fileType:
        file.fileType.split('/')[0] === 'application'
          ? 'Documents'
          : file.fileType.split('/')[0],
    }))
    .forEach((file) => {
      const existingIndex = groupedMedia.findIndex(
        (group) => group.type === file.fileType,
      )

      if (existingIndex === -1) {
        groupedMedia.push({
          type: file.fileType,
          files: [file],
        })
      } else {
        groupedMedia[existingIndex].files.push(file)
      }
    })

  return groupedMedia
}

export const formatLinks = (links = []) => ({
  type: 'Attachment',
  files: Object.keys(links).map((key) => {
    const link = links[key]
    return {
      id: link.id,
      fileName: link.name,
      fileType: 'Attachment',
      location: link.url,
    }
  }),
})
